import SAApi from './_saApi';
import httpClient from '@/apis/base/httpclient';

class SASaleInvoiceCancelAPI extends SAApi {
  constructor() {
    super();
  }
  controllerName = 'SASaleInvoiceCancels';
}

export default new SASaleInvoiceCancelAPI();
